export const pageSizeOptions = [10, 25, 50];
